"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class AppStudentId {
    init() {
        const root = document.querySelector("[data-student-id]");
        if (!root)
            return;
        const button = root.querySelector("[data-student-id-copy]");
        const value = root.querySelector("[data-student-id-value]");
        const label = root.querySelector("[data-student-id-label]");
        const status = root.querySelector("[data-student-id-status]");
        const manual = root.querySelector("[data-student-id-manual]");
        if (!button || !value || !label || !status || !manual)
            return;
        // The selectable field remains available when JavaScript cannot run.
        button.hidden = false;
        manual.hidden = true;
        let copying = false;
        let resetTimer;
        button.addEventListener("click", () => __awaiter(this, void 0, void 0, function* () {
            if (copying)
                return;
            copying = true;
            window.clearTimeout(resetTimer);
            root.classList.remove("is-copied");
            label.textContent = "Copiar";
            status.textContent = "";
            button.setAttribute("aria-busy", "true");
            try {
                // Only copy the ID; labels and formatting never enter the clipboard.
                yield navigator.clipboard.writeText(value.value);
                manual.hidden = true;
                root.classList.add("is-copied");
                label.textContent = "Copiado";
                status.textContent = "ID de estudiante copiado.";
                resetTimer = window.setTimeout(() => {
                    root.classList.remove("is-copied");
                    label.textContent = "Copiar";
                    status.textContent = "";
                }, 2000);
            }
            catch (_a) {
                // A denied or unavailable clipboard must still leave a way to copy.
                manual.hidden = false;
                status.textContent =
                    "No se pudo copiar automáticamente. Selecciona tu ID para copiarlo.";
                value.focus();
                value.select();
            }
            finally {
                copying = false;
                button.removeAttribute("aria-busy");
            }
        }));
    }
}
exports.default = AppStudentId;
